module.exports = __webpack_public_path__ + "img/about2.ca07b94.png";